import { createContext } from 'react';
import { THEME as theme } from './constants/theme';
import {
  getStaticBreakpoints as getBreakpoints,
  getStaticColors as getColors,
  getStaticIcons as getIcons,
  getStaticTypography as getTypography
} from './utils';

const Context = createContext({
  theme,
  getBreakpoints,
  getColors,
  getIcons,
  getTypography,
});

if (process.env.NODE_ENV !== 'production') {
  Context.displayName = 'Theme';
}

export default Context;
